export default __webpack_public_path__ + "static/bed-bath-beyond-5-dd-18f5634b7d5687482f814b55a44089b6.webp";